import script from "./ExchangeList.vue?vue&type=script&setup=true&lang=js"
export * from "./ExchangeList.vue?vue&type=script&setup=true&lang=js"

import "./ExchangeList.vue?vue&type=style&index=0&id=ec0eb99c&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec0eb99c"]])

export default __exports__